module.exports = __webpack_public_path__ + "static/media/InternshipPressureUnplugged.8368a175.png";